import {Modal} from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import React, {useEffect, useState} from 'react';

const ShowAllUserInputModal = (props) => {
    const [data, setData] = useState("");
    const {displayInfo} = props
    const {isShow} = props
    const {onClose} = props

    useEffect(() => {
        setData(displayInfo);
    },[displayInfo]);

    return (
        <>
            <Modal show={isShow}
                   onHide={onClose}
                   size={"lg"}
                   animation={false} style={{marginTop: 40}}>
                <Modal.Header>
                    <Modal.Title>Thông tin NL của các users</Modal.Title>
                    <Button variant='secondary' onClick={onClose}>
                        Close
                    </Button>
                </Modal.Header>
                <Modal.Body>
                    {data}
                </Modal.Body>
            </Modal>
        </>
    )
}

export default ShowAllUserInputModal;